import { Permission } from "@/shared/auth/permissions";
import { useCanDo } from "@/shared/auth/use-can-do";
import { useEntitlements } from "@/shared/entitlements/entitlements.context";
import { resolveFeatureEnabled } from "@/shared/entitlements/hooks/use-feature-enabled";
import type { ImportAccess } from "@/shared/import/import-group-access";

/// Which gated import fields the caller may map. Only the three permissions
/// the people catalogue gates on are resolved; anything else is refused, so a
/// new gated field stays hidden until it is wired here. Plan features read the
/// account's entitlements, permissive while they load like every other plan
/// affordance: the shore is the real gate, and the rewrite re-resolves the
/// group, so a column offered during that window is still dropped once the
/// plan says no.
export function useImportGrants(): ImportAccess {
  const canImportHr = useCanDo(Permission.HR_IMPORT_RUN);
  const canImportCompensation = useCanDo(Permission.SALARY_ASSIGNMENT_MANAGE_WORKSPACE);
  const canImportBank = useCanDo(Permission.EMPLOYEE_PROFILE_EDIT_SENSITIVE_WORKSPACE);
  const { features } = useEntitlements();
  return {
    isGranted: (permission) =>
      (permission === Permission.HR_IMPORT_RUN && canImportHr) ||
      (permission === Permission.SALARY_ASSIGNMENT_MANAGE_WORKSPACE && canImportCompensation) ||
      (permission === Permission.EMPLOYEE_PROFILE_EDIT_SENSITIVE_WORKSPACE && canImportBank),
    isEnabled: (feature) => resolveFeatureEnabled(features, feature),
  };
}
